<template>
    <div class="SubstationManagement">
        <div id="left">
            <div id="distributionchart" v-if="$store.state.project.currentProject.projectId=='5'||$store.state.project.currentProject.projectId=='4'||$store.state.project.currentProject.projectId=='6'">
                <Videoone1 @loopDetail="loopDetail" ></Videoone1>
            </div>
            <div id="distributionchart" v-else>
                <Videoone @loopDetail="loopDetail" ></Videoone>
            </div>
            <div id="areachart">
                <div class="areachart-one">
                    <h2>能耗同环比</h2>
                    <div id="disp">
                        <el-tabs tab-position="top" v-model="activeName" @tab-click="handleClick">
                            <el-tab-pane label="年同" name="first">
                                <div class="areachart-two">
                                    <div id="main" ref="initEcharts"></div>
                                    <div>
                                        <ul class="xinxi">
                                            <li class="xinxi-li" v-for="(item, index) in yearnew" :key="index">
                                                <div class="totol">
                                                    <span v-for="arr in item.class" :key="arr.id">{{
                          arr.name
                        }}</span>
                                                </div>
                                                <div class="parameter">
                                                    <h3>
                                                        {{
                            $store.getters.mqttVal(item.data)
                              ? $store.getters.mqttVal(item.data)
                              : item.data
                          }}
                                                    </h3>
                                                    <p>{{ index > 1 ? "%" : "kWh" }}</p>
                                                    <div class="disShow" v-if="item.imgred || item.imggen">
                                                        <img :src="item.imgred" v-if="yearArr > 0" />
                                                        <img :src="item.imggen" v-else-if="yearArr==0" />
                                                        <img src="" v-else>
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </el-tab-pane>
                            <el-tab-pane label="月环" name="second">
                                <div class="areachart-two">
                                    <div class="myCharts" ref="echartsDom"></div>
                                    <ul class="xinxi">
                                        <li class="xinxi-li" v-for="item in xinxi" :key="item.id">
                                            <div class="totol">
                                                <span v-for="arr in item.class" :key="arr.id">{{
                          arr.name
                        }}</span>
                                            </div>
                                            <div class="parameter">
                                                <h3>
                                                    {{
                            $store.getters.mqttVal(item.data)
                              ? $store.getters.mqttVal(item.data)
                              : item.data
                          }}
                                                </h3>
                                                <p>{{ item.keep }}</p>
                                                <div class="disShow" v-if="item.imgred || item.imggen">
                                                    <img :src="item.imgred" v-if="monthArr > 0" />
                                                    <img :src="item.imggen" v-else />
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </el-tab-pane>
                        </el-tabs>
                    </div>
                </div>
            </div>
        </div>
        <OverviewAllname v-if="$store.state.homeitem.testData == 0"></OverviewAllname>
        <Overviewitem v-else-if="$store.state.homeitem.testData == 1"></Overviewitem>
        <Overviewcomp v-else></Overviewcomp>
        <div slot="loopDetail" >
            <LoopDetail :width="width" :height="height" v-if="showLoopDetail" :tab="currentLoopTab"
                :loopUrl="currentLoopUrl" @closeLoopDetail="showLoopDetail = false"
                :currentLoop="loops.filter(item => item.subLoopUrl == currentLoopUrl)" />
        </div>
    </div>
</template>
<script>
    import {
        chainIndex
    } from "../../api/linkindex";
    import {
        play
    } from "../../api/login"
    import OverviewAllname from "./components/OverviewAll";
    import Overviewitem from "./components/Overviewitem";
    import LoopDetail from "../FirstDiagram/loopDetail"
    import { GetSecurityDevices, GET_AREAS,GET_AREA_LOOPS,projectJump } from "../../api/common";
    import {
        mapState,
        mapMutations
    } from "vuex";
    import Videoone from "./components/videoone";
    import Videoone1 from "./componentsnew/videoone";
    import Overviewcomp from "./components/Overviewcomp";

    export default {
        name: "SubstationManagement",
        data() {
            return {
                numId: "PROJECT_ID",
                loginID: "",
                id: 0,
                yearArr: 1,
                monthArr: 1,
                data1: [],
                data2: [],
                falg: 0,
                month: "",
                activeName: "second",
                yearnew: [],
                xinxi: [],
                myChart1: null,
                myChart2: null,
                loops: [],
                width: 1920,
                height: 870,
                showLoopDetail: false,
                currentLoopTab: '',
                currentLoopUrl:"",
                areaId: 1,
            };
        },

        //监听执行
        watch: {
            loginID(n, o) {
                this.loginID = n;
                this.xinxiData();
                this.initEcharts();
                this.inst();
                this.yearclick();
            },
            "$store.state.homeitem.pro": function (n, o) {
                this.xinxiData();
                this.initEcharts();
                this.inst();
                this.yearclick();
            },
            "$store.state.homeitem.areaId": function (n, o) {
                // console.log(n, o, "==============>");
                //   this.id = n;
                this.xinxiData();
                this.initEcharts();
                this.inst();
                this.yearclick();
                this.getLoops();
            },
        },
        // created(){
        //     if (this.getUrlKey("t") != null) {
        //         this.$store.commit("setToken", this.getUrlKey("t"));
        //         window.sessionStorage.setItem('token', this.getUrlKey("t"))
        //     }
        //     if (this.getUrlKey("n") != null) {
        //         this.$store.commit("setProjectId", this.getUrlKey("n"));
        //         // play.firmInfo().then(res => {
        //         //     this.$store.commit("setFirmInfo", res.data.data.firm);
        //         // })
        //         projectJump({projectId:this.getUrlKey("n")}).then(res => {
        //             this.$store.commit("setUser", res.data.data.user);
        //             this.$store.commit(
        //                 "setProjectInfo",
        //                 res.data.data.project
        //             );
        //             this.$store.commit("setFirmInfo", res.data.data.firm);
        //             //判断前后台数据
        //             this.$store.commit("ForegroundRadio", 1);
        //             this.$store.commit("webId", null);
        //             this.$store.commit("NavformDataId", 1);
        //             sessionStorage.setItem("NavformDataId", 1)
        //         })
        //     }
        // },
        mounted() {
            
            // this.websocketConnect()
            play.currentProjectInfo().then(res => {
                // console.log(res.data.data.project)
                this.$store.commit(
                    "setProjectInfo",
                    res.data.data.project
                );
                this.loginID = res.data.data.project.projectId;
                
            })
            GET_AREAS(1).then((res) => {
                this.areaId = res.data.data.areas[0].areaId;
                this.getLoops();
            });
            this.$store.commit("projectid", this.numId);
            this.yearclick(); //年同
            this.xinxiData(); //月环
            this.inst();
            this.initEcharts();
            
        },
        beforeDestroy() {
            this.$store.commit("setData", 0);                                                                                         
            this.$store.commit("Dthere", 1);
        },

        components: {
            OverviewAllname,
            Overviewitem,
            Videoone,                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          
            Overviewcomp,
            LoopDetail,
            Videoone1
        },
        methods: {
            
            getUrlKey(name) {
                return (
                    decodeURIComponent(
                        (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
                            location.href
                        ) || [, ""])[1].replace(/\+/g, "%20")
                    ) || null
                );
            },
            loopDetail(cmd, loopName) {
                this.showLoopDetail = true
                this.currentLoopUrl = loopName
                if (cmd == 'SwitchingClosing') {
                    this.currentLoopTab = '控制'
                } else if (cmd == 'RealTimeData') {
                    this.currentLoopTab = '电力数据'
                }
            },
            getLoops() {
                GET_AREA_LOOPS(this.areaId).then(res => {
                    this.loops = res.data.data.loops
                })
            },
            //  接收vuex切换站点参数并且渲染
            ...mapMutations(["setData"]),
            // itemclick() {
            //   this.$store.commit("setData", {
            //     testData: this.falg,
            //   });
            // },
            yearclick() {
                if (this.$store.state.homeitem.pro == "PROJECT_ID") {
                    this.id = this.loginID;
                } else {
                    this.id = this.$store.state.homeitem.areaId;
                }

                chainIndex
                    .chain("SEPARATED", "YEAR", this.$store.state.homeitem.pro, this.id)
                    .then((res) => {

                        if (res.data.data.result) {
                            this.$set(this.yearnew, 0, {
                                id: 1,
                                class: [{
                                        id: 1,
                                        name: "本",
                                    },
                                    {
                                        id: 2,
                                        name: "期",
                                    },
                                    {
                                        id: 3,
                                        name: "用",
                                    },
                                    {
                                        id: 4,
                                        name: "电:",
                                    },
                                ],
                                data: parseFloat(res.data.data.result[1].toFixed(2)),
                            }, );
                            this.$set(this.yearnew, 1, {
                                id: 2,
                                class: [{
                                        id: 1,
                                        name: "上",
                                    },
                                    {
                                        id: 2,
                                        name: "期",
                                    },
                                    {
                                        id: 3,
                                        name: "用",
                                    },
                                    {
                                        id: 4,
                                        name: "电:",
                                    },
                                ],
                                data: parseFloat(res.data.data.result[0].toFixed(2)),
                            });
                        }
                        // this.yearnew[1].data = parseFloat(res.data.data.result[0].toFixed(2));
                        // this.yearnew[0].data = parseFloat(res.data.data.result[1].toFixed(2));
                        if (this.yearnew.length) {
                            if (this.yearnew[1].data == 0 && this.yearnew[0].data == 0) {
                                this.$set(this.yearnew, 2, {
                                    id: 3,
                                    class: [{
                                            id: 1,
                                            name: "同",
                                        },
                                        {
                                            id: 2,
                                            name: "比",
                                        },
                                        {
                                            id: 3,
                                            name: "率:",
                                        },
                                    ],
                                    data: 0,
                                    imggen: "",
                                    imgred: "",
                                });
                                // this.yearnew[2].data = 0;
                            } else {
                                this.$set(this.yearnew, 2, {
                                    id: 3,
                                    class: [{
                                            id: 1,
                                            name: "同",
                                        },
                                        {
                                            id: 2,
                                            name: "比",
                                        },
                                        {
                                            id: 3,
                                            name: "率:",
                                        },
                                    ],
                                    data: ((this.yearnew[0].data - this.yearnew[1].data) /
                                            this.yearnew[1].data) *
                                        100 ==
                                        " Infinity " ?
                                        "100" : parseFloat(
                                            (
                                                ((this.yearnew[0].data - this.yearnew[1].data) /
                                                    this.yearnew[1].data) *
                                                100
                                            ).toFixed(2)
                                        ),
                                    imggen: require("../../assets/img/shang.png"),
                                    imgred: require("../../assets/img/xia.png"),
                                });
                                // this.yearnew[2].data =
                                //     ((this.yearnew[0].data - this.yearnew[1].data) /
                                //         this.yearnew[1].data) *
                                //     100 ==
                                //     " Infinity " ?
                                //     "100" :
                                //     parseFloat(
                                //         (
                                //             ((this.yearnew[0].data - this.yearnew[1].data) /
                                //                 this.yearnew[1].data) *
                                //             100
                                //         ).toFixed(2)
                                //     );
                            }

                            this.$set(this.yearnew, 3, {
                                id: 4,
                                class: [{
                                        id: 1,
                                        name: "累",
                                    },
                                    {
                                        id: 2,
                                        name: "计",
                                    },
                                    {
                                        id: 3,
                                        name: "同",
                                    },
                                    {
                                        id: 4,
                                        name: "比:",
                                    },
                                ],
                                data: this.yearnew[2].data,
                                imggen: require("../../assets/img/shang.png"),
                                imgred: require("../../assets/img/xia.png"),
                            }, );
                            if (this.yearnew[2].data > 0) {
                                this.yearArr = 0;
                            } else if (this.yearnew[2].data < 0) {
                                this.yearArr = 1;
                            } else {
                                this.yearArr = -1;
                            }
                        }

                    });
            },
    //   websocketConnect: function () {
    //             //let ws = new WebSocket('ws://192.168.33.188:37087/ebox/life');
    //             let ws = new WebSocket("wss://local.vrmaker.vip:37087/ebox/life");
    //             ws.binaryType = "arraybuffer";
    //             ws.onmessage = (res) => {
    //                 let uint8Array = new Uint8Array(res.data);
    //                 let messageBody = proto.MessageBody.decode(uint8Array);
                    
    //                 if (messageBody.dataType === 3) {
    //                     let json = {};
    //                     try {
    //                         json = JSON.parse(messageBody.alarmEvent.jsonData);
    //                         if (json.projectId !== this.projectId) {
    //                             return;
    //                         }
    //                     } catch (error) {
    //                         console.error("JSON parse fail");
    //                     }
    //                     let newNotifycation = {
    //                         alarm_event_type: json.eventType,
    //                         id: json.alarmId,
    //                         start_time: json.startTime,
    //                         loop_name: json.loopName,
    //                         device_name: json.deviceName,
    //                         alarm_type_desc: json.desc,
    //                         read_check: false,
    //                     };
    //                     this.$store.commit("appendData", newNotifycation);
    //                 } else if (messageBody.dataType === 2) {
    //                 //   console.log(messageBody.eBoxInfoList.eBoxInfos)
    //                     this.$store.commit("setEBoxInfo", messageBody.eBoxInfoList.eBoxInfos);
    //                 }
    //             };
    //         },
            xinxiData() {
                // console.log(this.loginID);
                if (this.$store.state.homeitem.pro == "PROJECT_ID") {
                    this.id = this.loginID;
                } else {
                    this.id = this.$store.state.homeitem.areaId;
                }

                chainIndex
                    .chain("ALTERNATE", "MONTH", this.$store.state.homeitem.pro, this.id)
                    .then((res) => {
                        // console.log(res)
                        if (res.data.data.result) {
                            this.$set(this.xinxi, 0, {
                                id: 1,
                                class: [{
                                        id: 1,
                                        name: "本",
                                    },
                                    {
                                        id: 2,
                                        name: "月",
                                    },
                                    {
                                        id: 3,
                                        name: "用",
                                    },
                                    {
                                        id: 4,
                                        name: "电:",
                                    },
                                ],
                                data: parseFloat(res.data.data.result[1].toFixed(2)),
                                keep: "kWh",
                            }, );

                            this.$set(this.xinxi, 1, {
                                id: 2,
                                class: [{
                                        id: 1,
                                        name: "上",
                                    },
                                    {
                                        id: 2,
                                        name: "月",
                                    },
                                    {
                                        id: 3,
                                        name: "用",
                                    },
                                    {
                                        id: 4,
                                        name: "电:",
                                    },
                                ],

                                data: parseFloat(res.data.data.result[0].toFixed(2)),
                                keep: "kWh",
                            }, )
                            // this.xinxi[0].data = parseFloat(res.data.data.result[1].toFixed(2));
                            // this.xinxi[1].data = parseFloat(res.data.data.result[0].toFixed(2));
                        }
                        if (this.xinxi.length) {
                            if (this.xinxi[0].data == 0 && this.xinxi[1].data == 0) {
                                // this.xinxi[2].data = 0;
                                this.$set(this.xinxi, 2, {
                                    id: 3,
                                    class: [{
                                            id: 1,
                                            name: "环",
                                        },
                                        {
                                            id: 2,
                                            name: "比",
                                        },
                                        {
                                            id: 3,
                                            name: "率:",
                                        },
                                    ],

                                    data: 0,
                                    imggen: "",
                                    imgred: "",
                                    keep: "%",
                                }, );
                            } else {
                                this.$set(this.xinxi, 2, {
                                    id: 3,
                                    class: [{
                                            id: 1,
                                            name: "环",
                                        },
                                        {
                                            id: 2,
                                            name: "比",
                                        },
                                        {
                                            id: 3,
                                            name: "率:",
                                        },
                                    ],

                                    data: ((this.xinxi[0].data - this.xinxi[1].data) / this.xinxi[1].data) *
                                        100 ==
                                        " Infinity " ?
                                        "100" : parseFloat(
                                            (
                                                ((this.xinxi[0].data - this.xinxi[1].data) /
                                                    this.xinxi[1].data) *
                                                100
                                            ).toFixed(2)
                                        ),
                                    imggen: require("../../assets/img/shang.png"),
                                    imgred: require("../../assets/img/xia.png"),
                                    keep: "%",
                                }, );
                                // this.xinxi[2].data =
                                //     ((this.xinxi[0].data - this.xinxi[1].data) / this.xinxi[1].data) *
                                //     100 ==
                                //     " Infinity " ?
                                //     "100" :
                                //     parseFloat(
                                //         (
                                //             ((this.xinxi[0].data - this.xinxi[1].data) /
                                //                 this.xinxi[1].data) *
                                //             100
                                //         ).toFixed(2)
                                //     );
                            }
                            this.$set(this.xinxi, 3, {
                                id: 4,
                                class: [{
                                        id: 1,
                                        name: "增",
                                    },
                                    {
                                        id: 2,
                                        name: "长",
                                    },
                                    {
                                        id: 3,
                                        name: "值:",
                                    },
                                ],

                                data: (this.xinxi[0].data - this.xinxi[1].data).toFixed(2),
                                keep: "kWh",
                            });

                            // this.xinxi[3].data = this.xinxi[0].data - this.xinxi[1].data;

                            if (this.xinxi[2].data > 0) {
                                this.monthArr = 0;
                            } else {
                                this.monthArr = 1;
                            }
                        }


                    });
            },
            //echarts
            inst() {
                let echarts = require("echarts");
                this.myChart2 = echarts.init(this.$refs.initEcharts);
                // 指定图表的配置项和数据
                var option = {
                    title: {
                        subtext: "用电量（kWh）",
                        top: "-4%",
                        //  itemGap:"100"
                    },
                    tooltip: {
                        trigger: "axis",
                    },
                    grid: {
                        containLabel: true,
                        left: "0%",
                        right: "0%",
                        top: "15%",
                        bottom: "5%",
                    },
                    legend: {
                        itemWidth: 12,
                        itemHeight: 12,
                        x: "center",
                        left: "right", // 图例的位置
                        textStyle: {
                            color: "#999999",
                        },

                        data: ["本期", "上期"],
                    },
                    // calculable: true,
                    xAxis: [{
                        type: "category",
                        data: [
                            "1月",
                            "2月",
                            "3月",
                            "4月",
                            "5月",
                            "6月",
                            "7月",
                            "8月",
                            "9月",
                            "10月",
                            "11月",
                            "12月",
                        ],
                    }, ],
                    yAxis: [{

                        type: "value",
                        scale: true,

                        min: 0,
                        splitNumber: 5,
                        // boundaryGap: [0, 20],
                        type: "value",
                    }, ],
                    series: [{
                            name: "本期",
                            type: "bar",
                        },
                        {
                            name: "上期",
                            type: "bar",
                        },
                    ],
                };
                if (this.$store.state.homeitem.pro == "PROJECT_ID") {
                    this.id = this.loginID;
                } else {
                    this.id = this.$store.state.homeitem.areaId;
                }
                let list = [];
                for (var i = 0; i < 12; i++) {
                    let p = chainIndex.chainyear(
                        "SEPARATED",
                        i,
                        "MONTH",
                        this.$store.state.homeitem.pro,
                        this.id
                    );
                    list.push(p);
                }
                let obj = {
                    tooltip: {
                        formatter: function (params) {
                            //自定义函数修改折线图给数据加单位
                            // console.log(params);
                            var str = ""; //声明一个变量用来存储数据
                            str += "<div>" + params[0].name + "</div>"; //显示日期的函数
                            for (var i = 0; i < params.length; i++) {
                                //图显示的数据较多时需要循环数据，这样才可以成功的给多条数据添加单位
                                str +=
                                    '<div style="color:' +
                                    params[i].color +
                                    '"><span>' +
                                    params[i].seriesName +
                                    "</span> : <span>" +
                                    (params[i].data ? params[i].data + "(kVh)" : "暂无") +
                                    "</span></div>";
                            }
                            return str;
                        },
                    },
                    series: [{
                            name: "本期",
                            data: [],
                            itemStyle: {
                                normal: {
                                    color: "#5AD8A6",
                                },
                            },
                        },
                        {
                            name: "上期",
                            data: [],
                            itemStyle: {
                                normal: {
                                    color: "#5B8FF9",
                                },
                            },
                        },
                    ],
                };
               
                Promise.all(list).then((res) => {
                    res.forEach((item, index) => {
                        obj.series[1].data.push(res[index].data.data.result[0].toFixed(2));
                        obj.series[0].data.push(res[index].data.data.result[1].toFixed(2));
                    }); 
                    this.myChart2.setOption(obj);  
                      
                });
               

                window.addEventListener("resize", () => {
                    this.myChart2.resize();
                });
                //  this.myChart2.hideLoading(); //动画
                // 使用刚指定的配置项和数据显示图表。
                this.myChart2.setOption(option);
            },
            initEcharts() {
                let echarts = require("echarts");
                this.myChart1 = echarts.init(this.$refs.echartsDom);
                
                this.myChart1.setOption({
                    title: {
                        subtext: "用电量（kWh）",
                        top: "-5%",
                    },
                    tooltip: {
                        position: function (pt) {
                            return [pt[0], "10%"];
                        },
                        formatter: "{a} {c} (kWh)", // 这里是鼠标移上去的显示数据
                        tooltip: {
                            trigger: "axis",
                            axisPointer: {
                                type: "cross",
                                label: {
                                    backgroundColor: "#6a7985",
                                },
                            },
                        },
                    },

                    //ech图形pading
                    grid: {
                        containLabel: true,
                        left: "0%",
                        right: "0%",
                        top: "18%",
                        bottom:'18%'
                    },

                    legend: {
                        itemWidth: 12,
                        itemHeight: 12,
                        x: "center",
                        data: ["本月", "上月"],
                        left: "right", // 图例的位置
                        textStyle: {
                            color: "#999999",
                        },
                    },
                    calculable: true,
                    xAxis: [{
                        show: true,

                        name: ["本月                                   上月"],

                        nameLocation: "middle",

                        type: "category",
                    }, ],
                    // 边界值
                    yAxis: [{
                        type: "value",
                        scale: true,
                        // max: 50000,
                        min: 0,
                        splitNumber: 5,
                        // boundaryGap: [0, 20],
                        type: "value",
                    }, ],

                    //柱子大小
                    series: [{
                            name: "本月",
                            type: "bar",
                            data: [0],
                            // barGap: "10%",
                            barWidth: 132, //柱图宽度
                            itemStyle: {
                                normal: {
                                    color: "#5AD8A6",
                                },
                            },
                        },
                        {
                            name: "上月",
                            type: "bar",
                            data: [0],
                            // barleft: 200,
                            barGap: "10%",
                            barWidth: 132, //柱图宽度
                            itemStyle: {
                                normal: {
                                    color: "#5B8FF9",
                                },
                            },
                        },
                    ],
                });
                if (this.$store.state.homeitem.pro == "PROJECT_ID") {
                    this.id = this.loginID;
                } else {
                    this.id = this.$store.state.homeitem.areaId;
                }
                // console.log(this.$store.state.homeitem.pro, this.id)
                chainIndex
                    .chain("ALTERNATE", "MONTH", this.$store.state.homeitem.pro, this.id)
                    .then((res) => {
                        // this.myChart1.hideLoading(); //动画
                        if (res.data.data.result) {
                            this.myChart1.setOption({
                                // 根据名字对应到相应的系列
                                series: [
                                    {
                                        name: "上月",
                                        data: [res.data.data.result[0].toFixed(2)],
                                    },
                                    {
                                        name: "本月",
                                        data: [res.data.data.result[1].toFixed(2)],
                                    },
                                ],
                            });
                        }
                    });

                window.addEventListener("resize", () => {
                    this.myChart1.resize();
                });
            },

            handleClick(tab, event) {
                this.myChart1.clear();
                this.myChart2.clear();
                this.xinxiData();
                this.initEcharts();
                this.inst();
                this.yearclick();
                console.log(event);
            },
        },
    };
</script>
<style scoped lang="less">
    .SubstationManagement {
        width: 100%;
        height: 100%;
        // .el-tabs{
        // .h(315) !important
        // }

        .el-tabs__nav {
            color: #999999 !important;
        }
    }

    .temperature {
        display: flex;
        width: 100%;
        font-size: 18rem;
        margin-bottom: 20rem;
        color: #666666;

        .temperature-item {
            margin-top: 3rem;
            width: 70%;
            margin-left: 30rem;
            display: flex;
            justify-content: space-between;
            padding-right: 20rem;
            color: #333333;
        }
    }

    #left {
        float: left;
        margin-top: 45rem;
        // background-color: gainsboro;

        #areachart {
            .w(1064);
            .h(320);
            background-color: #ffffff;
            padding: 23rem 0 0 24rem;

            .areachart-one {
                h2 {
                    .w(300);
                    // position: absolute;
                    top: 0rem;
                    font-size: 18rem;
                    font-weight: bold;
                    color: #333333;
                }

                #disp {
                    padding-right: 20rem;
                    font-weight: bold;
                    color: #333333;
                    font-size: 18rem;

                    span {
                        padding-right: 12rem;
                        padding-left: 12rem;
                    }
                }
            }

            .areachart-two {
                display: flex;
                justify-content: space-between;

                .xinxi {
                    position: relative;
                    padding-left: 15rem;
                    padding-right: 10rem;
                    padding-top: 20rem;

                    .xinxi-li:before {
                        content: "";
                        width: 6rem;
                        height: 6rem;
                        border-radius: 50%;
                        background: #666666;
                        vertical-align: middle;
                        margin-right: 10rem;
                    }

                    .totol {
                        font-size: 20rem;
                        font-weight: 400;
                        color: #666666;
                        width: 120rem;

                        span {
                            padding: 0 !important;
                        }
                    }

                    .parameter {
                        display: flex;
                        font-size: 20rem;
                        color: #333333;
                        margin-left: 10rem;
                        align-items: center;

                        //   h3 {
                        //     margin-left: 5rem;
                        //   }

                        p {
                            margin-top: 2rem;
                            margin-left: 3rem;
                            font-size: 14rem;
                        }
                    }
                }

            }
        }
    }

    .el-tabs__nav {
        color: #999999;
    }

    .distributionchart {
        z-index: 1 !important;
    }

    .myCharts {
        .w(700);
        .h(240);
    }

    #remotecontrolnumber {
        margin-left: 18rem;
    }

    #disp {
        // height: 315px !important;
    }

    #main {
        .w(700);
        .h(240);
    }

    #list {
        display: flex;
        justify-content: space-between;
    }

    .disShow {
        margin-left: 10rem;
        margin-top: -8rem;
        width: 20rem;
        height: 20rem;

        img {
            width: 20rem;
            height: 20rem;
        }
    }
</style>